module.exports = __webpack_public_path__ + "static/media/arkos3.ac6d3124.jpg";